import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommissionSalePromotion } from 'src/app/model/commission-sale-promotion';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCommissionSalePromotionsComponent } from 'src/app/shared/modal-commission-sale-promotions/modal-commission-sale-promotions.component';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-commission-detail-hold-release',
  templateUrl: './commission-detail-hold-release.component.html',
  styleUrls: ['./commission-detail-hold-release.component.css']
})
export class CommissionDetailHoldReleaseComponent implements OnInit {
  // estado pagina
  public page: string = 'CommissionSalePromotion';
  public viewStatus = 0;  // -1:nada, 0:spinner, 1:tabla
  public listSalePromotions: CommissionSalePromotion[] = [];
  public listSalePromotionsLog: any[] = [];

  public active: number = 1;

  @Input() selectedCommissionHoldRelease: any;
  listCommissionHoldReleaseLogs: any[] = [];


  // Opciones de Datatable
  @ViewChild(DataTableDirective, { static: false })
  private datatableElement: DataTableDirective;

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    // responsive: {
    //   details: {
    //     renderer: function ( columns ) {
    //       var data = columns.map(function(col) {
    //         return col.hidden ?
    //               '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
    //                   '<td>&bull; <b>'+col.title+':</b>'+'</td> '+
    //                   '<td>'+col.data+'</td>'+
    //               '</tr>' :
    //               '';
    //       }).join('');

    //       return data ?
    //           $('<table/>').append( data ) :
    //           false;
    //     }
    //   }
    // },
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 },
      { responsivePriority: 2, width: 100, targets: -2 }
    ],
    select: 'single',
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    // dom: 'Bfrtip',
    autoWidth: false,
    // pagingType: 'full_numbers',
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  dtOptionsLog = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    // dom: 'Bfrtip',
    autoWidth: false,
    // pagingType: 'full_numbers',
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private commissionSalePromotionsService: CommissionSalePromotionsService,
    public utils: UtilitiesService,
    private creator: CreatorService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
    console.log("ngOnInit...");
    console.log("...", this.selectedCommissionHoldRelease);
    this.listCommissionHoldReleaseLogs = this.selectedCommissionHoldRelease.requestCommissionsHoldReleaseList;
    console.log("...", this.listCommissionHoldReleaseLogs);
    // this.getCatalogs();
    this.viewStatus = 1;
  }

  close = () => {
    this.modalService.dismissAll('failure');
  }

  //
  add = () => {
    let salePromotion = this.creator.newCommissionSalePromotion();
    salePromotion.promotionDateIni = null;
    salePromotion.promotionDateFin = null;
    salePromotion.saleAmountFrom = null;
    salePromotion.saleAmountTo = null;
    salePromotion.additionalSchemaBase = false;
    salePromotion.digitalOrigin = true;
    salePromotion.unifielDigifiel = true;
    salePromotion.traditionalOrigin = true;
    salePromotion.minCreditAdv = false;
    salePromotion.minCreditAdvPerc = null;
    salePromotion.observations = '';
    let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.salePromotion = salePromotion;
    modalRef.componentInstance.page = this.page;
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  edit = (salePromotion: CommissionSalePromotion) => {
    let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: true, keyboard: false });
    modalRef.componentInstance.salePromotion = { ...salePromotion };
    modalRef.componentInstance.salePromotionOld = { ...salePromotion };
    modalRef.componentInstance.page = this.page;
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  detail = (salePromotion: any) => {
    console.log("Detail clicked...", salePromotion);
    // let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
    // modalRef.componentInstance.salePromotion = { ...salePromotion };
    // modalRef.componentInstance.page = this.page;
    // modalRef.componentInstance.mode = 'detail';
    // modalRef.result.then(
    //   data => console.log(data),
    //   reason => {
    //     console.log(reason);
    //   }
    // );
  }
  delete = (salePromotion: CommissionSalePromotion) => {
    let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.salePromotion = { ...salePromotion };
    modalRef.componentInstance.page = this.page;
    modalRef.componentInstance.mode = 'delete';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  toggleActive = (salePromotion: CommissionSalePromotion) => {
    var date = new Date();
    let currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let from = salePromotion.promotionDateFin.split("-");
    let f = new Date(+from[0], +from[1] - 1, +from[2]);

    console.log(">> salePromotion.promotionDateFin=", salePromotion.promotionDateFin);
    console.log(">> currentDate=", currentDate);
    console.log(">> f=", f);

    if (!salePromotion.activeId && currentDate > f) {
      this.toastr.error('No se puede activar una promoción ya vencida!');
    } else {
      let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.salePromotion = { ...salePromotion };
      modalRef.componentInstance.page = this.page;
      modalRef.componentInstance.mode = 'toggleActive';
      modalRef.result.then(
        data => console.log(data),
        reason => {
          console.log(reason);
          this.viewStatus = 0;
          this.getCatalogs();
        }
      );
    }
  }
  logDetails = (salePromotionLog: any) => {
    let modalRef = this.modalService.open(ModalCommissionSalePromotionsComponent, { centered: true, size: 'lg', scrollable: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.salePromotion = null;
    modalRef.componentInstance.page = this.page;
    modalRef.componentInstance.mode = 'detail';
    modalRef.componentInstance.logDetails = salePromotionLog.details;
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
      }
    );
  }

  // INFO
  getCatalogs = () => {
    forkJoin(
      this.commissionSalePromotionsService.getListSalePromotions()
    )
      .pipe(
        tap(([salePromoResp]: [any]) => {
          if (salePromoResp) {
            this.listSalePromotions = salePromoResp.data;
            this.viewStatus = 1;
          }
          else throwError;
        }),
        catchError(error => {
          console.log(error);
          this.viewStatus = -1;
          return of(this.toastr.error('Ocurrió un error al obtener la información'));
        })
      )
      .subscribe();
  }


}
